<template>
	<div class="formTabWrapper">
		<div class="formTabCard">
			<field
					v-if="trailerTypeId === 2"
					margin="0"
					width="170px"
					label="Hours"
					isReadonly
					tooltip="Hours from last WO"
					:setInputValue="hours"
					isNumber
					type="number"
			></field>
			<field
					margin="0"
					width="220px"
					label="Origin value"
					placeholder="Enter value"
					icon="dollar"
					:setInputValue="originValue"
					isNumber
					type="number"
					isDisabled
					@updateInput="onInput($event, 'originValue')"
			></field>
		</div>

		<div class="formTabTableWrap">
			<div class="formTabTableWrap_top">
				<div class="formTabTableWrap_top-title">Timeline</div>
				<div class="formTabTableWrap_top-add">

					<v-btn
							:disabled="getPermissionAction" @click="onRenewalValuePopupHandler(true)" type="button"
							depressed
							class="mainBtn mainBtn-text"
					>
						<span class="btnIco"><svg-sprite icon-id="addItem" width="20" height="20"></svg-sprite></span>
						<span class="btnText">Add truck value</span>
					</v-btn>

				</div>
			</div>
			<div class="formTabTableWrap_body">
					<renewal-value
							v-if="trucksValueFilter"
							:filter="trucksValueFilter"
							:items="trucksValueList"
							:truckId="truckId"
							:getPermissionAction="getPermissionAction"
							@updateEdit="onEdit"
							@updateRemoveItem="setRemoveItem"
					></renewal-value>
			</div>
		</div>

		<renewal-value-popup
				v-if="isRenewalValuePopup"
				@updateRenewalValueList="onRenewalValueList"
				@updateClose="onRenewalValuePopupHandler(false)"
				:truckNumber="truckNumber"
				:editItem="editItem"
				:itemsYears="trucksValueYears"
				:originValue="originValue"
		></renewal-value-popup>

		<remove-block
				v-if="isRemove"
				@updateRemoveItem="onRemoveItem"
				@updateRemoveClose="isRemove = false"
		></remove-block>

	</div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
// components
import RenewalValue from "@/components/Maintenance/Trucks/TruckForm/RenewalValue/RenewalValue";

// async components
const RenewalValuePopup =
		() => import("@/components/Maintenance/Trucks/TruckForm/RenewalValuePopup/RenewalValuePopup");
const RemoveBlock = () => import("@/shared/RemoveBlock/RemoveBlock");

export default {
	name: "TruckValueTab",
	components: {
		RenewalValue,
		RenewalValuePopup,
		RemoveBlock
	},
	props: {
		truckId: Number,
		trailerTypeId: Number,
		truckNumber: String,
		hours: String,
		getPermissionAction: Boolean,
	},
	data: () => ({
		isRenewalValuePopup: false,
		editItem: null,
		isRemove: false,
		removeItem: null
	}),
	computed: mapGetters([ 'trucksValueFilter', 'trucksValueList', 'trucksValueYears', 'originValue' ]),
	methods: {
		...mapActions([
			'onTrucksValueEdit',
			'onTrucksValue',
			'onTrucksValueRemove',
			'onTrucksValueCreate',
		]),
		onInput({ value }, key) {
			this.$emit('updateValueTab', { value, key });
		},
		async onEdit(item) {
			this.editItem = await this.onTrucksValueEdit(item.id);
			this.isRenewalValuePopup = true;
		},
		async setRemoveItem(id) {
			this.removeItem = { truckId: this.truckId, id };
			this.isRemove = true;
		},
		onRenewalValuePopupHandler(value) {
			this.isRenewalValuePopup = value;
			if (!value) this.editItem = null;
		},
		async onRemoveItem() {
			await this.onTrucksValueRemove(this.removeItem);
			this.isRemove = false;
		},
		async onRenewalValueList(values) {
			await this.onTrucksValueCreate({ truckId: this.truckId, values });
		}
	},
	async mounted() {
		await this.onTrucksValue(this.truckId);
	}
};
</script>

<style scoped lang="scss">
@import "@/assets/style/components/formTab/formTabCard.scss";
@import "@/assets/style/components/formTab/formTabCard";
@import "@/assets/style/components/formTab/formTabTableWrap";
.formTabCard {
	display:  flex;
	align-items:  center;
	gap: 10px;
}

</style>
